<template v-if="contentType === 1">
  <iframe
    title="video"
    class="border-[2px] border-[#F7F7F7] rounded-[8px]"
    :src="jwPlayerSrc()"
    frameborder="0"
    scrolling="no"
  />
</template>

<script lang="ts">
export default {
  props: {
    jwLink: {
      type: String,
      default: "",
    },
  },
  methods: {
    jwPlayerSrc() {
      return import.meta.env.VITE_AUTOCLUB_CDN + "?jwLink=" + this.jwLink;
    },
  },
};
</script>

<style scoped>
iframe {
  aspect-ratio: 16 / 9;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
</style>
